/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionReportingWrapper } from '../../models/transaction-reporting-wrapper';

export interface ApiTransactionYearGet$Params {
  year: number;
  'api-version'?: string;
}

export function apiTransactionYearGet(http: HttpClient, rootUrl: string, params: ApiTransactionYearGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionReportingWrapper>> {
  const rb = new RequestBuilder(rootUrl, apiTransactionYearGet.PATH, 'get');
  if (params) {
    rb.path('year', params.year, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionReportingWrapper>;
    })
  );
}

apiTransactionYearGet.PATH = '/api/transaction/{year}';
